import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { CompanySectorZodSchema } from "src/api/client-api/company/useGetOneOrganization.ts";
import { isQueryReady } from "src/api/axiosClient/utils";

export const getOneOrganizationSectorKey = "getOneCompanySector" as const;

type Options = {
    sectorId?: number;
};

export const useGetOneOrganizationSector = (options: Options) => {
    const { sectorId } = options;
    const isEnabled = sectorId !== undefined;

    const query = useQuery({
        queryKey: [getOneOrganizationSectorKey, sectorId],
        enabled: isEnabled,
        queryFn: async () => {
            if (!sectorId) return;
            const response = await loggedInApiCall.get(`/api/organization_sectors/${sectorId}`);
            return response;
        },
        select: (request) => {
            if (!request) return;
            const sector = request.data;
            const data = zodParseWithLog(sector, CompanySectorZodSchema, getOneOrganizationSectorKey);
            return data;
        },
    });

    const isReady = isQueryReady(query, isEnabled);

    return {
        sector: query.data,
        isReady,
        ...query,
    };
};
